<template>
  <div id="def1" ref="main" class="container" />
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "HXistogram",
  props: {
    linChart: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null, // 接收实例对象
    };
  },
  watch: {
    linChart(newVal) {
      if (newVal !== "") {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (myChart != null && myChart !== "" && myChart !== undefined) {
        myChart.dispose(); // 销毁
      }
      var myChart = echarts.init(this.$refs.main);
      // 绘制图表
      var option = {
        backgroundColor: "#fff",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "2%",
          right: "4%",
          bottom: "5%",
          top: "16%",
          containLabel: true,
        },
        legend: {
          right: "20px",
          top: 0,
          textStyle: {
            color: "#333",
          },
          itemWidth: 10,
          itemHeight: 10,
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: 20,
          },
          type: "category",
          data: this.linChart[1].name,
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(0,0,0,0.5)",
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
          },
        },
        yAxis: {
          name: "分数",
          type: "value",
          max: "65",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#666",
            },
            symbol: ["none", "arrow"],
            symbolSize: [5, 12],
            symbolOffset: [0, 10],
          },
          axisLabel: {
            color: "#999",
            textStyle: {
              fontSize: 12,
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
          },
        },
        series: [
          {
            name: "学生测评",
            type: "bar",
            barWidth: "25%",
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示数值
                  position: "center", //数值在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666666", //字体颜色
                    fontSize: 10, //字体大小
                  },
                },
                color: "#B6D6FF",
              },
            },
            data: this.linChart[1].value,
          },
          {
            name: "平均能力水平",
            type: "line",
            barWidth: "25%",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#FFCA71",
              },
            },
            data: this.linChart[0].value,
          },
        ],
      };

      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 110%;
  height: 300px;
  // background: skyblue;
}
</style>
